export default __webpack_public_path__ + "media/images/upholstery-afb0459833422e3a6829b8f6e375bc92.png";